<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ building().heading }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="form" class="property-form">

      <mat-form-field class="medium-width" subscriptSizing="fixed">
        <mat-label>Typ av objekt</mat-label>
        <mat-select
            (selectionChange)="setTypeOfObject()"
            formControlName="typeOfObject">
          @for (type of objectTypes; track $index) {
            <mat-option [value]="type">
              {{ type }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (showValue && scenario() === scenarioTypes[0]) {
        <mat-form-field class="medium-width" subscriptSizing="fixed">
          <mat-label>Köpeskilling</mat-label>
          <input formControlName="objectValue"
                 matInput
                 name="objectValue"
                 spbFormatNumber>
        </mat-form-field>
      }
      @if (showValue && scenario() !== scenarioTypes[0]) {
        <mat-form-field style="width: 300px" subscriptSizing="fixed">
          <mat-label>Amorterings- och låneutrymmesgrundande värde</mat-label>
          <input formControlName="mortgageRequirementValue"
                 matInput
                 name="mortgageRequirementValue"
                 spbFormatNumber>
        </mat-form-field>
      }
      @if (showValue && scenario() !== scenarioTypes[0]) {
        <mat-form-field subscriptSizing="fixed">
          <mat-label>Amorteringsgrundande skuld</mat-label>
          <input formControlName="mortgageRequirementDebt"
                 matInput
                 name="mortgageRequirementDebt"
                 spbFormatNumber>
        </mat-form-field>
      }
      @if (form.controls.typeOfObject.valid) {
        <mat-form-field class="medium-width" subscriptSizing="fixed">
          <mat-label>Driftskostnad</mat-label>
          <input
              formControlName="runCost"
              matInput
              name="runCost"
              spbFormatNumber>
          <span matTextSuffix>kr/mån</span>
        </mat-form-field>
      }

      @if (showValue) {
        <mat-form-field class="medium-width" subscriptSizing="fixed"
                        [style.width.px]="360">
          <mat-label>Datum för amorterings- och låneutrymmesgrundande värde</mat-label>
          <input matInput
                 [matDatepicker]="picker"
                 formControlName="mortgageRequirementDate"
                 name="mortgageRequirementDate">

          <mat-datepicker-toggle
              [disabled]="controlService.locked()"
              [for]="picker"
              matIconSuffix>
          </mat-datepicker-toggle>

          <mat-datepicker #picker></mat-datepicker>

          @if (revaluationDateText) {
            <mat-hint>{{ revaluationDateText }}</mat-hint>
          }
        </mat-form-field>
      }

      @if (showFee) {
        <div>
          <mat-form-field class="medium-width" subscriptSizing="fixed">
            <mat-label>{{ rentOrFee }}</mat-label>
            <input
                formControlName="fee"
                matInput
                name="Fee"
                spbFormatNumber
            >
            <span matTextSuffix>kr/mån</span>
          </mat-form-field>
        </div>
      }
    </form>
  </mat-card-content>
</mat-card>